<label [ngClass]="name.errors ? 'text-danger' : ''" *ngIf="label">{{ label }}</label>
<ng-select
  #selectRef
  [(ngModel)]="ngModel"
  [items]="items"
  bindValue="{{ bindValue }}"
  bindLabel="{{ bindLabel }}"
  (search)="OnSearch($event)"
  [loading]="loading"
  (open)="onOpen()"
  [clearOnBackspace]="true"
  (clear)="loadMore()"
  [clearable]="true"
  (ngModelChange)="ngModelChange.emit($event)"
  [searchable]="true"
  [virtualScroll]="true"
  (scrollToEnd)="loadMore()"
  [multiple]="multiple"
  (change)="onChange($event)"
  #name="ngModel"
  [disabled]="disabled"
  (blur)="OnBlur()"
  [required]="required"
  [addTag]="addTagFn ? onAddTag.bind(this) : addNewText"
  [dropdownPosition]="comboPosition"
  [ngClass]="{ 'no-margin': !applyMargins }"
>
  <ng-template ng-label-tmp let-item="item">
    <span>{{ getCombinedLabel(item) }}</span>
  </ng-template>

  <ng-template ng-option-tmp let-item="item" let-index="index">
    <label class="h6">{{ item[bindLabel] }}</label>
    <div class="d-flex">
      @for (x of bindSubObj ; track x.key; let i = $index) { @if( x.value && subRowObj(
      item,x.value)) {
      <div>
        <small class="text-success" style="font-size: 10px">{{ x.key }}</small> :
        <small class="text-success me-2" style="font-size: 10px">
          {{ subRowObj(item, x.value) }}
        </small>
        @if(bindSubObj[i+1]?.value) {
        {{ ShowSeperator(item, i + 1) }}
        }
      </div>
      } }
    </div>
  </ng-template>
</ng-select>
